/**
 * Different attribute types starts with `Attribute:`
 */
export var AttributeBaseType;
(function (AttributeBaseType) {
    AttributeBaseType["Editable"] = "Attribute:Editable";
    AttributeBaseType["MultiOption"] = "Attribute:MultiOption";
    AttributeBaseType["SingleOption"] = "Attribute:SingleOption";
    AttributeBaseType["Boolean"] = "Attribute:Boolean";
    AttributeBaseType["Substructure"] = "Attribute:Substructure";
    /**
     * @deprecated Remove in favor of component `AttributeInfoText`
     */
    AttributeBaseType["Static"] = "Attribute:Static";
})(AttributeBaseType || (AttributeBaseType = {}));
//# sourceMappingURL=AttributeBaseType.js.map